<script>
import clientApiDrive from "@/services/http/api-drive/client";
import MdpOublieForm from "@/components/organisms/connexion/mdp-oublie-form";
import { states } from "@/components/molecules/mixins/form.mixin";
import StateOverlay from "@/components/molecules/state-overlay";

export default {
  components: {
    MdpOublieForm,
    StateOverlay
  },
  emits: ["resetPassword"],
  computed: {
    isLoading() {
      return this.state === states.LOADING;
    }
  },
  data() {
    return {
      state: null,
      error: null
    };
  },
  methods: {
    async resetPassword(data) {
      this.state = states.LOADING;
      try {
        await this.$apiDrive
          .use(clientApiDrive)
          .resetPassword(data.email, data.captcha);
        this.state = states.SUCCESS;
        this.$emit("resetPassword", data.email);
      } catch (error) {
        this.state = states.ERROR;
        this.error = this.$apiDrive.getErrorData(error);
        if (this.error && this.error.status_code === 403) {
          this.error.message =
            'Pour des raisons de sécurité, la fonction "Mot de passe oublié" n\'est pas possible pour nos clients CoraPro.\nVeuillez contacter le correspondant CoraPro de votre magasin.';
        }
      }
    }
  }
};
</script>

<template>
  <StateOverlay
    :is-loading="isLoading"
    message="Envoi de votre demande en cours..."
  >
    <MdpOublieForm
      :state="state"
      :error="error"
      @resetPassword="resetPassword"
    />
  </StateOverlay>
</template>
